import { render } from "./RequisiteTypesPage.vue?vue&type=template&id=3006230b&scoped=true"
import script from "./RequisiteTypesPage.vue?vue&type=script&lang=js"
export * from "./RequisiteTypesPage.vue?vue&type=script&lang=js"

import "./RequisiteTypesPage.vue?vue&type=style&index=0&id=3006230b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3006230b"]])

export default __exports__